// extracted by mini-css-extract-plugin
export var buttonOwnMeal = "recipe-search-modal-module--button-own-meal--f89b7";
export var error = "recipe-search-modal-module--error--77c9d";
export var filterBox = "recipe-search-modal-module--filter-box--b4e73";
export var filtersWrapper = "recipe-search-modal-module--filters-wrapper--4a4ae";
export var list = "recipe-search-modal-module--list--c8d5c";
export var modal = "recipe-search-modal-module--modal--f906b";
export var noContent = "recipe-search-modal-module--no-content--0e283";
export var recipesLoader = "recipe-search-modal-module--recipes-loader--170c4";
export var separator = "recipe-search-modal-module--separator--1d0e4";